import React from "react";
import SignatureHTML from "./SignatureHTML";
import { SignatureForm } from "./Forms";
import { ISignatureProps, ISignatureState } from "./Models";
import { Container, Row, Col, Navbar } from "react-bootstrap";
import { Dialog } from "./SignatureDialog";
import { isMobile } from "react-device-detect";
import AlertMessage from "../core/Alert";

export class SignatureView extends React.Component<
    ISignatureProps,
    ISignatureState
> {
    private dialogRef: React.RefObject<Dialog>;
    private htmlStr: string;
    private renderedStr: string;

    constructor(props: ISignatureProps) {
        super(props);

        this.dialogRef = React.createRef();
        this.htmlStr = "";
        this.renderedStr = "";

        this.state = {
            fullName: "",
            email: "",
            workPhone: "",
            cellPhone: "",
            jobTitle: "",
            pronouns: "",
            org: "",
            location: "",
            isValid: true,
            isMobile: isMobile,
        };
    }

    handleChange(values: ISignatureState) {
        console.log("values", values);
        this.setState({
            fullName: values.fullName || "",
            email: values.email || "",
            workPhone: values.workPhone || "",
            jobTitle: values.jobTitle || "",
            org: values.org || "",
            pronouns: values.pronouns || "",
            location: values.location || "",
            cellPhone: values.cellPhone || "",
        });
    }

    handleSubmit(values: ISignatureState, isValid: boolean) {
        if (isValid) {
            this.setState({ isValid: true });

            if (this.dialogRef.current) {
                this.dialogRef.current.showDialog(this.state);
            }
        } else {
            this.setState({ isValid: false });
        }
    }

    render() {
        return (
            <div>
                <Dialog ref={this.dialogRef} {...this.state} />
                <Container>
                    <Row noGutters={true}>
                        <Col sm={12} lg={12} md={12}>
                            <Navbar variant="dark" bg="dark">
                                <Navbar.Brand>Email Signature</Navbar.Brand>
                            </Navbar>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <AlertMessage
                                show={this.state.isMobile}
                                variant="danger"
                                dismissible={true}
                                style={{ marginTop: 10 }}
                                onClick={() => {
                                    this.setState({ isMobile: false });
                                }}
                            >
                                Mobile Outlook app does not support HTML or Rich
                                Text.
                            </AlertMessage>
                        </Col>
                    </Row>
                    <Row>
                        <Col
                            sm={{ span: 12, offset: 0 }}
                            lg={{ span: 12, offset: 0 }}
                            md={{ span: 12, offset: 0 }}
                        ></Col>
                    </Row>
                    <Row>
                        <Col
                            lg={{ span: 3, offset: 0 }}
                            md={{ span: 4, offset: 0 }}
                            sm={{ span: 12, offset: 0 }}
                            style={{ marginTop: 20 }}
                        >
                            <SignatureForm
                                initialValues={this.state}
                                onSubmition={(values, isValid) =>
                                    this.handleSubmit(values, isValid)
                                }
                                onValueChange={(values) =>
                                    this.handleChange(values)
                                }
                            />
                        </Col>
                        <Col
                            sm={{ span: 12, offset: 0 }}
                            lg={{ span: 9, offset: 0 }}
                            md={{ span: 8, offset: 0 }}
                            style={{ marginTop: 20 }}
                        >
                            <h6>Preview</h6>
                            <div className="preview" id="outlookDiv">
                                <SignatureHTML
                                    fullName={this.state.fullName}
                                    email={this.state.email}
                                    workPhone={this.state.workPhone}
                                    cellPhone={this.state.cellPhone}
                                    jobTitle={this.state.jobTitle}
                                    pronouns={this.state.pronouns}
                                    org={this.state.org}
                                    location={this.state.location}
                                    isValid={this.state.isValid}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}
